/**
 * 避免因为出现登录之类的webview，导致触发了页面的visibilityState
 */
class WebViewOpen {
  private open = false;
  public changeStatus(value: boolean = false) {
    this.open = value;
  }
  public getState() {
    return this.open;
  }
}

export default new WebViewOpen();
